module.exports = __webpack_public_path__ + "img/04f198c2e9b6c5e43a48d09a44f345fb.svg";